module.exports = __webpack_public_path__ + "img/iconfont.31f55228.svg";